import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageBanner from '../components/PageBanner/PageBanner';
import gallery from '../data/galleryManifest.json';
import './Gallery.css';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'house', label: 'House Life' },
  { key: 'sports', label: 'Sport' },
];

export default function Gallery() {
  const [searchParams] = useSearchParams();
  const initialFilter = FILTERS.some((f) => f.key === searchParams.get('filter'))
    ? searchParams.get('filter')
    : 'all';
  const [filter, setFilter] = useState(initialFilter);
  const [activeIndex, setActiveIndex] = useState(null);

  const photos = useMemo(
    () => (filter === 'all' ? gallery : gallery.filter((p) => p.category === filter)),
    [filter]
  );

  const openAt = (i) => setActiveIndex(i);
  const close = () => setActiveIndex(null);
  const next = (e) => { e.stopPropagation(); setActiveIndex((i) => (i + 1) % photos.length); };
  const prev = (e) => { e.stopPropagation(); setActiveIndex((i) => (i - 1 + photos.length) % photos.length); };

  const changeFilter = (key) => {
    setFilter(key);
    setActiveIndex(null);
  };

  useEffect(() => {
    if (activeIndex === null) return;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') setActiveIndex((i) => (i + 1) % photos.length);
      if (e.key === 'ArrowLeft') setActiveIndex((i) => (i - 1 + photos.length) % photos.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [activeIndex, photos.length]);

  return (
    <section className="gallery-page">
      <PageBanner
        image="/gallery/full/event-073.jpg"
        eyebrow="Moments & memories"
        title="Gallery"
        subtitle="Socials, outreach, sport, and everything in between: a running record of life at House TAU."
      />

      <div className="section">
        <div className="container">

          <div className="gallery-filters">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                className={`gallery-filters__btn ${filter === f.key ? 'is-active' : ''}`}
                onClick={() => changeFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="gallery-grid">
            {photos.map((photo, i) => (
              <button
                key={photo.id}
                className="gallery-grid__item"
                onClick={() => openAt(i)}
                aria-label={`Open photo ${i + 1}`}
              >
                <img src={photo.thumb} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </div>

      {activeIndex !== null && (
        <div className="lightbox" onClick={close}>
          <button className="lightbox__close" onClick={close} aria-label="Close">×</button>
          <button className="lightbox__nav lightbox__nav--prev" onClick={prev} aria-label="Previous">‹</button>
          <img
            src={photos[activeIndex].full}
            alt=""
            className="lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="lightbox__nav lightbox__nav--next" onClick={next} aria-label="Next">›</button>
          <div className="lightbox__count">{activeIndex + 1} / {photos.length}</div>
        </div>
      )}
    </section>
  );
}
